import { Box, Button, FormHelperText, TextField } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Formik } from "formik";
import * as Yup from "yup";
import useMounted from "hooks/useMounted";
import useLoginGuard from "hooks/useLoginGuard";
import { useNavigate } from "react-router";
import useAuth from "hooks/useAuth";
import QRCode from "react-qr-code";
interface Props {
    qrcode?: string;
}

let timer: NodeJS.Timeout;
const SetUpTotpFormik: FC<Props> = props => {
    const mounted = useMounted();
    const { settings, saveSettings } = useLoginGuard();
    const navigate = useNavigate();
    const { user, verifyTotpCode, confirmSignIn, refreshTotpCode } = useAuth();
    const [countdown, setCountdown] = useState<number>(120); // I guest the expire time could be 180 seconds
    const [isSessionExpired, setIsSessionExpired] = useState<boolean>(false);
    useEffect(() => {
        if (props.qrcode !== "qrcode") return;
        timer = setInterval(() => {
            setCountdown(countdown - 1);
            if (countdown <= 1) {
                setCountdown(120);
                refreshTotpCode(settings.currEmail);
            }
        }, 1000);
        return () => {
            if (Boolean(timer)) {
                clearInterval(timer);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countdown]);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            }}>
            {props.qrcode === "qrcode" && (
                <Box
                    mb={2}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}>
                    <QRCode value={user?.totpLink ?? ""} size={128} />
                    <Box mt={1}>The QR code will update in {countdown} seconds</Box>
                </Box>
            )}
            <Formik
                initialValues={{
                    verification: "",
                    submit: null
                }}
                validationSchema={Yup.object({
                    verification: Yup.string().max(255).required("Authentication code is required")
                })}
                onSubmit={async (
                    values,
                    { setErrors, setStatus, setSubmitting }
                ): Promise<void> => {
                    try {
                        // todo: save qrcode into database;
                        // user?.totpLink
                        if (settings.currStep === "MFA_SETUP") {
                            await verifyTotpCode(values.verification);
                        }

                        if (settings.currStep === "SOFTWARE_TOKEN_MFA") {
                            await confirmSignIn(values.verification);
                        }
                        navigate("/landing");
                        if (mounted.current) {
                            setStatus({ success: true });
                            setSubmitting(false);
                        }
                    } catch (err: any) {
                        console.log("MFA error ==>", err);
                        if (err.code === "NotAuthorizedException") {
                            setIsSessionExpired(true);
                        }
                        if (mounted.current) {
                            setStatus({ success: false });
                            setErrors({ submit: err.message });
                            setSubmitting(false);
                        }
                    }
                }}>
                {({
                    errors,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values
                }): JSX.Element => (
                    <form noValidate onSubmit={handleSubmit} {...props} style={{ width: "100%" }}>
                        <input
                            type="text"
                            name="_prevent_auto_complete_name"
                            autoComplete="off"
                            readOnly
                            style={{ display: "none" }}
                        />
                        <input
                            type="password"
                            name="_prevent_auto_complete_pass"
                            autoComplete="new-password"
                            readOnly
                            style={{ display: "none" }}
                        />
                        <TextField
                            autoFocus
                            error={Boolean(touched.verification && errors.verification)}
                            fullWidth
                            helperText={touched.verification && errors.verification}
                            label="Authentication code"
                            margin="normal"
                            name="verification"
                            onChange={handleChange}
                            type="text"
                            value={values.verification}
                            variant="standard"
                        />
                        {errors.submit && (
                            <Box>
                                <FormHelperText error>{errors.submit}</FormHelperText>
                            </Box>
                        )}
                        {!isSessionExpired ? (
                            <Box
                                sx={{
                                    mt: 5,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%"
                                }}>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        saveSettings({
                                            ...settings,
                                            currStep: "LOGIN"
                                        });
                                    }}>
                                    CANCEL
                                </Button>
                                <LoadingButton
                                    color="primary"
                                    sx={{ height: 39, fontSize: 14 }}
                                    loading={isSubmitting}
                                    type="submit"
                                    variant="contained">
                                    SUBMIT
                                </LoadingButton>
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    mt: 5,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%"
                                }}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => {
                                        saveSettings({
                                            ...settings,
                                            currStep: "LOGIN"
                                        });
                                    }}>
                                    Back to login
                                </Button>
                            </Box>
                        )}
                    </form>
                )}
            </Formik>
        </Box>
    );
};

export default SetUpTotpFormik;
